module.exports = __webpack_public_path__ + "static/media/workshop-HRTABLExOffice365-01.d0080ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/workshop-HRTABLExOffice365-01.jpg
// module id = 390
// module chunks = 0